module.exports = __webpack_public_path__ + "img/DE00565.f64f1d2f.png";